// src/apis/uploadApi.js
import apiClient from './ApiInterceptor';

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  // apiClient ya incluye la base URL; especificamos encabezado multipart
  const response = await apiClient.post('/upload/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const fetchImages = async () => {
  const response = await apiClient.get('/upload/images');
  return response.data;
};
